/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Show_Previous_EventInputs */

const en_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show previous event`)
};

const fr_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher l'evenement precedent`)
};

const de_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis anzeigen`)
};

const it_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra evento precedente`)
};

const ru_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать предыдущее событие`)
};

const es_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar evento anterior`)
};

const zh_cn2_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示上一个事件`)
};

const ja_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントを表示`)
};

const hi_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला कार्यक्रम दिखाएँ`)
};

const pt_pt2_player_show_previous_event = /** @type {(inputs: Player_Show_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar evento anterior`)
};

/**
* | output |
* | --- |
* | "Show previous event" |
*
* @param {Player_Show_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_show_previous_event = /** @type {((inputs?: Player_Show_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Show_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_show_previous_event(inputs)
	if (locale === "de") return de_player_show_previous_event(inputs)
	if (locale === "it") return it_player_show_previous_event(inputs)
	if (locale === "ru") return ru_player_show_previous_event(inputs)
	if (locale === "es") return es_player_show_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_player_show_previous_event(inputs)
	if (locale === "ja") return ja_player_show_previous_event(inputs)
	if (locale === "hi") return hi_player_show_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_player_show_previous_event(inputs)
	return en_player_show_previous_event(inputs)
});